import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e17bcc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-toolbar" }
const _hoisted_2 = { class: "remark" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "toolbar" }

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useSlideHandler from '@/hooks/useSlideHandler'
import useCreateElement from '@/hooks/useCreateElement'
import { getImageDataURL } from '@/utils/image'
import { ShapePoolItem } from '@/configs/shapes'
import { VIEWPORT_SIZE } from '@/configs/canvas'

import MobileThumbnails from '../MobileThumbnails.vue'
import FileInput from '@/components/FileInput.vue'
import { Button } from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SlideToolbar',
  setup(__props) {

const ButtonGroup = Button.Group

const slidesStore = useSlidesStore()
const { viewportRatio, currentSlide } = storeToRefs(slidesStore)

const { createSlide, copyAndPasteSlide, deleteSlide, } = useSlideHandler()
const { createTextElement, createImageElement, createShapeElement } = useCreateElement()

const insertTextElement = () => {
  const width = 400
  const height = 56

  createTextElement({
    left: (VIEWPORT_SIZE - width) / 2,
    top: (VIEWPORT_SIZE * viewportRatio.value - height) / 2,
    width,
    height,
  }, { content: '<p>新添加文本</p>' })
}

const insertImageElement = (files: FileList) => {
  if (!files || !files[0]) return
  getImageDataURL(files[0]).then(dataURL => createImageElement(dataURL))
}

const insertShapeElement = (type: 'square' | 'round') => {
  const square: ShapePoolItem = {
    viewBox: [200, 200],
    path: 'M 0 0 L 200 0 L 200 200 L 0 200 Z',
  }
  const round: ShapePoolItem = {
    viewBox: [200, 200],
    path: 'M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z',
  }
  const shape = { square, round }

  const size = 200

  createShapeElement({
    left: (VIEWPORT_SIZE - size) / 2,
    top: (VIEWPORT_SIZE * viewportRatio.value - size) / 2,
    width: size,
    height: size,
  }, shape[type])
}

const remark = computed(() => currentSlide.value?.remark || '')

const handleInputMark = (e: Event) => {
  const value = (e.target as HTMLTextAreaElement).value
  slidesStore.updateSlide({ remark: value })
}

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_IconCopy = _resolveComponent("IconCopy")!
  const _component_IconDelete = _resolveComponent("IconDelete")!
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_IconPicture = _resolveComponent("IconPicture")!
  const _component_IconSquare = _resolveComponent("IconSquare")!
  const _component_IconRound = _resolveComponent("IconRound")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("textarea", {
        value: _unref(remark),
        placeholder: "点击输入演讲者备注",
        onInput: _cache[0] || (_cache[0] = $event => handleInputMark($event))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(ButtonGroup), { class: "row" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            style: {"flex":"1"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(createSlide)()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconPlus, { class: "icon" }),
              _createTextVNode(" 新幻灯片")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            style: {"flex":"1"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(copyAndPasteSlide)()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconCopy, { class: "icon" }),
              _createTextVNode(" 复制")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            style: {"flex":"1"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(deleteSlide)()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconDelete, { class: "icon" }),
              _createTextVNode(" 删除")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(ButtonGroup), { class: "row" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            style: {"flex":"1"},
            onClick: _cache[4] || (_cache[4] = ($event: any) => (insertTextElement()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconFontSize, { class: "icon" }),
              _createTextVNode(" 文字")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), { style: {"flex":"1"} }, {
            default: _withCtx(() => [
              _createVNode(FileInput, {
                onChange: _cache[5] || (_cache[5] = files => insertImageElement(files))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconPicture, { class: "icon" }),
                  _createTextVNode("图片 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            style: {"flex":"1"},
            onClick: _cache[6] || (_cache[6] = ($event: any) => (insertShapeElement('square')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconSquare, { class: "icon" }),
              _createTextVNode(" 矩形")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            style: {"flex":"1"},
            onClick: _cache[7] || (_cache[7] = ($event: any) => (insertShapeElement('round')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconRound, { class: "icon" }),
              _createTextVNode(" 圆形")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(MobileThumbnails)
  ]))
}
}

})